import { Outlet } from "react-router-dom";

const MedicationItem = () => {

  return <Outlet />
}

export default MedicationItem;